module.exports = __webpack_public_path__ + "img/aParty_1208_H.cddfeb45.jpg";